import { render, staticRenderFns } from "./SubProfile.vue?vue&type=template&id=19f205a2&scoped=true&"
import script from "./SubProfile.vue?vue&type=script&lang=js&"
export * from "./SubProfile.vue?vue&type=script&lang=js&"
import style0 from "./SubProfile.vue?vue&type=style&index=0&id=19f205a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f205a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VApp,VDialog})
